import React from 'react'
import { File, FileJson, FileSpreadsheet, FileText } from 'lucide-react'

const iconForFilename = (filename?: string | null) => {
  const ext = (filename || '').split('.').pop()?.trim().toLowerCase()
  switch (ext) {
    case 'csv':
    case 'xlsx':
    case 'xls':
      return FileSpreadsheet
    case 'json':
      return FileJson
    case 'txt':
    case 'md':
    case 'pdf':
    case 'docx':
      return FileText
    default:
      return File
  }
}

/** Icon that matches an attached file's type (spreadsheet, JSON, text, ...). */
const FileTypeIcon: React.FC<{ filename?: string | null; className?: string }> = ({ filename, className }) => {
  const Icon = iconForFilename(filename)
  return <Icon className={className} strokeWidth={2} />
}

export default FileTypeIcon
